module.exports = __webpack_public_path__ + "img/AK0093-WB.59d818a7.jpg";